import api from '../../../App/socket';

export const getBikeModels = (where, limit, offset) =>

/* for (const key in where) {
        if (where.hasOwnProperty(key)) {
            if (where[key] === false) {
                where[key] = undefined;
            }
        }
    } */

    api.send({
        api: 'db',
        model: 'Bike_model',
        action: 'Read',
        options: {
            attributes: ['wwym_priority', 'leadomatic_priority', 'mileage_limit', 'min_age', 'we_dont_want', 'name', 'bike_type', 'cc', 'variation'],
            limit,
            offset,
            include: [
                {
                    model: 'Bike_brand',
                    attributes: 'all',
                },
            ],
            where,
        },
    }).then(response => response).catch(error => error);
export const countBikeModels = (where, option) => api.send({
    api: 'db',
    model: option === 'variants' ? 'Bike_variant' : 'Bike_model',
    action: 'Count',
    options: {
        include: option === 'variants' ? {
            path: 'ref_bike_model',
            model: 'Bike_model',
            attributes: 'all',
        } : null,
        where,
    },
}).then(response => response).catch(error => error);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/requests/get_all_bikes_request.js